import { Card, Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { DashboardMetric } from "../../../dashboard";
import { DistroDashboardData, StatusCount } from "../../../../models";

interface DistributionMetricsProps {
    showMobile: boolean;
    data: DistroDashboardData | undefined;
}

export function DistributionMetrics({ data, showMobile }: Readonly<DistributionMetricsProps>) {
    const navigate = useNavigate();

    if (!data) return null;

    const handleDonorMetricClick = (metric: StatusCount) => {
        if (metric.listSlug) {
            navigate(`/lists/${metric.listSlug}/cases`);
        }
    };

    const handleTissueMetricClick = (metric: StatusCount) => {
        if (metric.listSlug) {
            navigate(`/lists/${metric.listSlug}/tissues`);
        }
    };

    return (
        <div className={`distro-metrics px-3 ${showMobile && "show-mobile"}`}>
            <Row className="gx-3">
                <Col md={8} xs={12} className="mb-3">
                    <Card className="bg-primary text-white">
                        <Card.Header>Tissues</Card.Header>
                        <Card.Body className="bg-canvas">
                            <Row>
                                {data.tissueMetrics?.map((metric) => (
                                    <Col key={metric.status} xs={6} sm={3}>
                                        <DashboardMetric
                                            title={metric.status}
                                            value={metric.count}
                                            onClick={() => handleTissueMetricClick(metric)}
                                        />
                                    </Col>
                                ))}
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={4} xs={12} className="mb-3">
                    <Card className="bg-primary text-white">
                        <Card.Header>Donors</Card.Header>
                        <Card.Body className="bg-canvas">
                            <Row>
                                {data.donorMetrics?.map((metric) => (
                                    <Col key={metric.status}>
                                        <DashboardMetric
                                            title={metric.status}
                                            value={metric.count}
                                            onClick={() => handleDonorMetricClick(metric)}
                                        />
                                    </Col>
                                ))}
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </div>
    );
}
